// import { Box } from "@mui/material";
import { Box, Button, Dialog, DialogContent, DialogTitle, Tooltip, Typography } from "@mui/material";
import { type MRT_ColumnDef } from "material-react-table";
import {
  extractNameFromEmail,
  formatDurationFromSeconds,
} from "../../utils/utils";
import { useState } from "react";
import AnalyticsUserInteraction from "./AnalyticsUserInteraction";
import "../../styles/AnalyticsPage.css";
import "../../styles/analytics.css";

const initialSort = { sort_field: "email", sort_order: "asc" };

const columns=(start_time: string, end_time: string ): MRT_ColumnDef<any>[] => [
  {
    accessorKey: "email",
    header: "Name",
    Cell: ({ cell, row }: { cell: any, row: any }) => {
      const employeeName = row.original?.employeeName;  
      return (
        <>
        <Tooltip title={cell.getValue() as string } placement="top" arrow>
            <Box 
            >
              <Typography 
              >
              {extractNameFromEmail(employeeName, cell.getValue() as string)}
              </Typography>
            </Box>
        </Tooltip>
        </>
      );
    },
    enableColumnFilter: false,
    enableSorting: true,
    grow: true,
    minSize: 225,
    size: 200,
  },
  {
    accessorKey: "client_list",
    header: "Clients Rated Ratio",
    Header: () => (
      <Tooltip title="Rated Clients / Total Clients" placement="top">
        <span>Clients Rated Ratio</span>
      </Tooltip>
    ),
    muiTableBodyCellProps: {
      sx: { textAlign: "center" }, // Centers text in body cells
    },
    Cell: ({ cell }: { cell: any }) => {
      const ratedClientCount = cell.row.original.rated_client_count; // Get rated_client_count from the row data
      const totalClient = cell.row.original.total_client; // Get total_client from the row data
      let percentage = "NA"; // Default value for NA if not calculable
    // Calculate percentage only if totalClient is greater than 0
    if (totalClient > 0) {
      percentage = ((ratedClientCount / totalClient) * 100).toFixed(0); // Calculate percentage without decimals
    }

    return (
      <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
        {totalClient > 0
          ? `${ratedClientCount} / ${totalClient} (${percentage}%)`
          : `${ratedClientCount} / ${totalClient} (NA)`}
      </Box>
    );
  },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 180,
    size: 180,
  },
  {
    accessorKey: "num_meetings",
    header: "No. of interactions",
    Cell: ({ cell, row }: { cell: any; row: any }) => {
      const [openDialog, setOpenDialog] = useState(false);

      const handleOpen = () => {
        setOpenDialog(true);
      };

      const handleClose = () => {
        setOpenDialog(false);
      };
      // Formatting the timestamps

      const employee_email_ids = row.original.email;
  
      return (
        <>
                     <Button
              onClick={handleOpen}
              sx={{
                textDecoration: "none",
                textDecorationColor: "rgba(25, 118, 210, 0.4)",
                color: "#1976d2",
                textTransform: "capitalize",
                fontFamily: 'var(--font-family)',
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              {`${cell.getValue() || 0} interactions`}
            </Button>
            <Dialog open={openDialog} fullWidth maxWidth="lg">
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <button
                onClick={handleClose}
                className="summary-dialog-box__close-btn"
                style={{
                  top:"auto"
                }}
              >
                &times;
              </button>
            </DialogTitle>
            <DialogContent sx={{ p: 2 }}>
              <AnalyticsUserInteraction
              employee_email_ids={employee_email_ids}
              newUserTeamData={row.original.newUserTeamData}
              startTime={start_time}
              endTime={end_time}
              tableFilters={row.original.tableFilters}
              />
              </DialogContent>
            </Dialog>
          </>
        );
      },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 150,
    // maxSize: 200,
    size: 150,
  },
  {
    accessorKey: "avgCallDuration",
    header: "Avg. Call Duration",
    Cell: ({ row }: { row: any }) => {
      const value = row.original.avgCallDuration;
      return (
        <Box sx={{ fontFamily: 'var(--font-family)', fontSize: "14px" }}>
              {value != null
              ? (value < 60
                  ? formatDurationFromSeconds(value)
                  : formatDurationFromSeconds(value).replace(/\d+s/, "").trim())
              : "NA"}
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    size: 180,
  },
  {
    accessorKey: "avgSelfTalkTime",
    header: "Avg. Self Talk Time",
    Cell: ({ row }: { row: any }) => {
      const value = row.original.avgSelfTalkTime;
      return (
        <Box sx={{ fontFamily: 'var(--font-family)', fontSize: "14px" }}>
              {value != null
              ? (value < 60
                  ? formatDurationFromSeconds(value)
                  : formatDurationFromSeconds(value).replace(/\d+s/, "").trim())
              : "NA"}
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    size: 180,
  },
 {
    accessorKey: "totalClients",
    header: "Total Clients",
    Cell: ({ cell }: { cell: any }) => {
      if(!cell.getValue() || cell.getValue() === null){
        return (
          <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
            -
          </Box>
        );
      }
      return (
        <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
          {cell.getValue() || 0}
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 110,
    size: 110,
 },
 {
    accessorKey: "detractor_rated_count",
    header: "Red Clients", // still required as a string for type safety
    Header: () => (
    <Box display="flex" alignItems="center">
      <Box
        className= "rated-circle"
        sx={{ backgroundColor: "#F4442F" }}
      />
      <span
        style={{
          fontFamily: 'var(--font-family)',
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        Clients
      </span>
    </Box>
  ),
    Cell: ({ cell, row }: { cell: any, row: any }) => {
      if(!cell.getValue() || cell.getValue() === null){
        return (
          <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
            -
          </Box>
        );
      }
      return (
        <Box onClick={() => {
          row.original.ClientCountClick(
            "Detractor",
            false,
            row.original?.email,
            row.original?.profileOrgId,
            undefined,
            row.original?.employeeName
          );
        }}>
          <h1 className= "analytics-clickable-text">
          {cell.getValue() || 0}
          </h1>
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 110,
    size: 110,
 },
 {
    accessorKey: "neutral_count",
    header: "Yellow Clients",
    Header: () => (
      <Box display="flex" alignItems="center">
        <Box
          className= "rated-circle"
          sx={{ backgroundColor: "#FFCD2A" }}
        />
        <span
          style={{
            fontFamily: 'var(--font-family)',
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          Clients
        </span>
      </Box>
    ),
    Cell: ({ cell, row }: { cell: any, row: any }) => {
      if(!cell.getValue() || cell.getValue() === null){
        return (
          <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
            -
          </Box>
        );
      }
      return (
        <Box onClick = {() => {
          row.original.ClientCountClick(
            "Neutral",
            false,
            row.original?.email,
            row.original?.profileOrgId,
            undefined,
            row.original?.employeeName
          );
        }} >
          <h1 className= "analytics-clickable-text">
          {cell.getValue() || 0}
          </h1>
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 110,
    size: 120,
  },
  {
    accessorKey: "promoter_count",
    header: "Green Clients",
    Header: () => (
      <Box display="flex" alignItems="center">
        <Box
          className= "rated-circle"
          sx={{ backgroundColor: "#32BD00" }}
        />
        <span
          style={{
            fontFamily: 'var(--font-family)',
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          Clients
        </span>
      </Box>
    ),
    Cell: ({ cell, row }: { cell: any, row: any }) => {
      if(!cell.getValue() || cell.getValue() === null){
        return (
          <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
            -
          </Box>
        );
      }
      return (
        <Box onClick = {() => {
          row.original.ClientCountClick(
            "Promoter",
            false,
            row.original?.email,
            row.original?.profileOrgId,
            undefined,
            row.original?.employeeName
          );
        }}>
          <h1 className= "analytics-clickable-text">
          {cell.getValue() || 0}
          </h1>
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 120,
    size: 120,
 },
 {
    accessorKey: "not_rated_count",
    header: "Not Rated Clients",
    Header: () => (
      <Box display="flex" alignItems="center">
        <Box
          className= "rated-circle"
          sx={{ backgroundColor: "#EFEBFB" }}
        />
        <span
          style={{
            fontFamily: 'var(--font-family)',
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
         Not Rated Clients
        </span>
      </Box>
    ),
    Cell: ({ cell, row }: { cell: any, row: any }) => {
      if(!cell.getValue() || cell.getValue() === null){
        return (
          <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
            -
          </Box>
        );
      }
      return (
        <Box onClick={() => {
          row.original.ClientCountClick(
            "NotRated",
            false,
            row.original?.email,
            row.original?.profileOrgId,
            undefined,
            row.original?.employeeName
          );
        }}>
          <h1 className= "analytics-clickable-text">
            {cell.getValue() || 0}
          </h1>
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 150,
    size: 150,
 },
  {
    accessorKey: "detractor_percent",
    header: "Red Clients Ratio",
    Header: () => (
      <Tooltip title="Detractor Count / Rated Count" placement="top">
        <span>Red Clients Ratio</span>
      </Tooltip>
    ),
    muiTableBodyCellProps: {
      sx: { textAlign: "center" }, // Centers text in body cells
    },
    Cell: ({ row }: { row: any }) => {
      const { detractor_rated_count, rated_client_count } = row.original;
    const ratio = `${detractor_rated_count} / ${rated_client_count}`;
    let percentage = "NA"; // Default value for NA if not calculable
    if (rated_client_count > 0) {
      percentage = ((detractor_rated_count / rated_client_count) * 100).toFixed(0); // Calculate percentage without decimals
    }

    return (
      <Box sx={{fontFamily:'var(--font-family)', fontSize:"14px", fontWeight:"400"}}>
        {rated_client_count > 0
          ? `${ratio} (${percentage}%)`
          : `${ratio} (NA)`}
      </Box>
    );
  },
    enableColumnFilter: false,
    enableSorting: false,
    grow: false,
    minSize: 150,
    // maxSize: 200,
    size: 150,
  },
];

export { columns, initialSort };
